import UuidValueObject from '@/domain/shared/uuid/UuidValueObject';

export default class InscriptionId extends UuidValueObject {}
